import(/* webpackMode: "eager" */ "/home/pi/prod/strawman/apps/web/app/(landing)/resource/[slug]/style.css");
;
import(/* webpackMode: "eager", webpackExports: ["ResourceDetails"] */ "/home/pi/prod/strawman/apps/web/components/ResourceDetails/index.tsx");
